function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import classnames from 'classnames';
import Utility from "../../Utility/Utility";
import Colors from "../../Color/Colors";
import { SocialBlockFooter } from "../../Block/SocialBlockFooter/SocialBlockFooter";
import { CollapsiblePanel } from "../../CollapsiblePanel/CollapsiblePanel";
import { Button } from "../../Button/Button/Button";
import { Container } from "../../Container/Container/Container";
import styles from "./FooterMenuSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FooterMenuSlice = function FooterMenuSlice(_ref) {
  var menu = _ref.menu,
    social = _ref.social;
  var renderFooterMenus = function renderFooterMenus() {
    if (!menu) {
      return null;
    }
    return menu.map(function (srcMenu, i) {
      // In Reimagine 1st level menu item cannot be link.
      var menu = _objectSpread(_objectSpread({}, srcMenu), {}, {
        url: ''
      });
      var isLink = menu.url && menu.url.length !== 0;
      var hasSubMenu = menu.subMenu && menu.subMenu.length !== 0;
      return /*#__PURE__*/_jsx("div", {
        "data-e2e-name": "footer_menu",
        children: /*#__PURE__*/_jsx(CollapsiblePanel, {
          variant: "accordion",
          collapsed: true,
          collapsible: hasSubMenu,
          collapsibleBreakpoint: false,
          iconPosition: "right",
          iconColor: Colors.colorWhite,
          iconSize: "16px",
          className: styles.menuTitle,
          contentOuterClassName: styles.leftPanel,
          buttonAttributes: menu.attributes,
          buttonText: menu.text,
          buttonUrl: menu.url,
          buttonNewWindow: menu.newWindow,
          buttonStyle: isLink ? 'secondary--with-link' : 'secondary',
          labels: {
            close: "Click to close ".concat(menu.text, " submenu"),
            open: "Click to open ".concat(menu.text, " submenu")
          },
          children: /*#__PURE__*/_jsx("ul", {
            className: styles.menuList,
            children: menu.subMenu && menu.subMenu.map(function (item, j) {
              return /*#__PURE__*/_jsx("li", {
                className: styles.menuListItem,
                "data-e2e-name": "footer_menu_list_item",
                children: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
                  url: item.url,
                  newWindow: item.newWindow,
                  accessibilityLabel: Utility.getLinkTitleText(item.text || '', item.title),
                  type: "no-style"
                }, item.attributes), {}, {
                  children: item.text
                }))
              }, "footer-submenu-".concat(i, "-").concat(j));
            })
          })
        })
      }, "footer-menu-".concat(i));
    });
  };
  return /*#__PURE__*/_jsx("div", {
    id: "footer-menu",
    className: classnames('webview', styles.footerMenu),
    role: "contentinfo",
    "aria-label": "Footer Menu",
    "data-e2e-name": "footer_menu",
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.social,
        children: /*#__PURE__*/_jsx(SocialBlockFooter, {
          config: social
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.columnWrapper,
        children: /*#__PURE__*/_jsx("div", {
          className: styles.right,
          "data-e2e-name": "footer_right",
          children: /*#__PURE__*/_jsx("div", {
            className: styles.rightMenus,
            children: renderFooterMenus()
          })
        })
      })]
    })
  });
};